import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import InputEmprestimo from "../Componets/InputEmprestimo";
import LabelGeral from "../Componets/LabelGeral";
import DateGeral from "../Componets/DateGeral";
import Vector from "../imagem/Vector.svg";
import iconPessoa from "../imagem/iconPessoa.svg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 330,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  height: 300,
  p: 4,
  borderRadius: 3,
};

function EfetuarDevolucao({
  open,
  cancelar,
  devolver,
  titulo,
  aluno,
  dataDevolvendo,
  setDataDevolvendo,
}) {
  return (
    <div>
      <Modal
        open={open}
        onClose={cancelar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
                margin: -15,
              }}
            >
              <Button onClick={cancelar}>
                <img src={Vector} alt="" />
              </Button>
            </div>
            <Typography variant="h6" component="h6">
              Efetuar devolução
            </Typography>
            <Typography variant="p" component="p">
              {titulo}
            </Typography>
          </div>

          <div
            style={{
              justifyContent: "center",
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <LabelGeral
              nome="Nome"
              style={{
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                left: 10,
                fontFamily: "Roboto",
                fontSize: 20,
              }}
            />
            <InputEmprestimo
              value={aluno}
              disabled={true}
              placeholder=""
              icon={iconPessoa}
            />
          </div>

          <div
            style={{
              display: "flex",
              marginTop: 25,
              justifyContent: "space-between",
            }}
          >
            <div>
              <LabelGeral
                nome="Data de entrega"
                style={{
                  display: "flex",
                  fontFamily: "Roboto",
                  fontSize: 16,
                }}
              />

              <DateGeral
                dataDevolvendo={dataDevolvendo}
                setDataDevolvendo={setDataDevolvendo}
                width={265}
              />
            </div>
          </div>

          <div
            className="buttons"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 20,
            }}
          >
            <Button
              onClick={cancelar}
              variant="contained"
              style={{
                color: "var(--cor-roxoEscuro)",
                backgroundColor: "var(--cor-roxoInput)",
                border: "2px solid var(--cor-roxoEscuro)",
                borderRadius: "0.5em",
                fontSize: 18,
                width: 160,
                top: 34,
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={devolver}
              variant="contained"
              style={{
                color: "var(--cor-branco)",
                backgroundColor: "var(--cor-roxoEscuro)",
                border: "2px solid var(--cor-roxoEscuro)",
                borderRadius: "0.5em",
                fontSize: 18,
                width: 160,
                top: 34,
              }}
            >
              Devolver
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default EfetuarDevolucao;
